

































































import { ObjectFactory } from '@/config/objectFactory';
import { EventBus } from '@/main';
import { ServiceRequest } from '@/types/entity';
import { ToastEvent } from '@/types/event';
import { ApiRequest, Document } from '@/types/request';
import { ApiResponse, UploadFileResponse } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';

@Component({
    mixins: [validationMixin],
    props: {
        requestId: String,
    },
    data() {
        return {
            noteText: '',
        };
    },
})
export default class AddThreadModal extends Vue {
    private show = true;
    private documents: File[] = [];

    get canSubmit() {
        return this.$data.noteText.trim() !== '' || this.documents.length > 0;
    }

    private setDocuments(event: any) {
        const files: FileList = event.target.files;
        Array.from(files).forEach((file) => {
            const filename = file.name.toLowerCase();
            if (filename.endsWith('.pdf') || filename.endsWith('.png') ||
                filename.endsWith('.jpeg') || filename.endsWith('.jpg')) {
                this.documents.push(file);
            } else {
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, {
                    message: 'File types should be PDF, JPEG, PNG',
                    title: 'Invalid file format',
                    varient: 'danger',
                    timeout: 5000,
                } as ToastEvent);
            }
        });
        const element = this.$refs['file-input'] as any;
        element.reset();
    }

    private removeDocument(index: number) {
        this.documents.splice(index, 1);
    }

    private async uploadDocument(file: File): Promise<ApiResponse<UploadFileResponse>> {
        const formData = new FormData();
        formData.append('file', file);
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL:  this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_RESOURCE}`,
            data: formData,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<UploadFileResponse>(apiRequest);
        if (response.success && response.data) {
            return response;
        } else {
            CommonUtils.showError(response);
            throw new Error(JSON.stringify(response));
        }
    }

    private async addThreadEntry() {
        const iHttpService = ObjectFactory.getHttpService();
        const uploadedDocs: Document[] = [];
        for (const file of this.documents) {
            const uploadResult = (await this.uploadDocument(file));
            if (uploadResult.data) {
                uploadedDocs.push({
                name: file.name,
                filename: file.name,
                resourceId: uploadResult.data.fileName,
            });
            }
        }
        const threadRequest = {
                noteText: this.$data.noteText || '',
                documents: uploadedDocs,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_REQUEST}/${this.$props.requestId}/addThread`,
            data: threadRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.put<ServiceRequest>(apiRequest);
        if (response.success) {
            const toastEvent: ToastEvent = {
                message: `Added Thread Successfully`,
                title: 'Success',
                varient: 'success',
                timeout: 2000,
            };
            EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            this.close();
        } else {
            CommonUtils.showError(response);
            this.close();
        }
    }

    private close() {
        this.$emit('close');
        this.$data.noteText = '';
        this.$data.documents = [];
    }

}
